var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"users"},_vm._l((_vm.allUsers),function(user,index){return _c('li',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(user.name),expression:"user.name"}],key:index,class:{'master': user.master},style:({
      zIndex: _vm.users.length-index
    })},[_c('Avatar',{attrs:{"src":user.photo_media_url && !user.photo_media_url.includes(_vm.defaultImageUrl) ? user.photo_media_url : null,"name":user.name,"size":"30px","radius":"15px","resize":"100x100x1"}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d69bbcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Parts/RelatedUser.vue
// module id = null
// module chunks = 